import type { SVGProps } from "react";
export interface PlaneVerticalOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneVerticalOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneVerticalOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.968 15.776a1.125 1.125 0 0 1-2.092-.806v-1.097a.88.88 0 0 0-.326-.681l-.092-.065-5.547-3.414a1.13 1.13 0 0 1-.536-.958v-2.75c0-.5-.23-1.307-.63-2-.194-.337-.396-.589-.57-.742a.8.8 0 0 0-.174-.123c-.046.022-.163.09-.342.292-.26.294-.522.732-.72 1.226l-.049.105a1.125 1.125 0 0 1-2.037-.945l.22-.5a6.3 6.3 0 0 1 .9-1.378c.44-.496 1.133-1.06 2.028-1.06l.253.015c.578.07 1.056.37 1.408.68.412.362.757.83 1.031 1.306.537.931.932 2.125.932 3.124v2.12l5.012 3.086.17.112a3.13 3.13 0 0 1 1.319 2.55v1.206c0 .247-.057.484-.159.697Zm-4.343 5.731a1.625 1.625 0 0 1-2.139 1.541L12 21.885l-3.486 1.163a1.625 1.625 0 0 1-2.139-1.54v-.98c0-.828.33-1.622.916-2.208l1.084-1.086v-1.957l-4.396 1.354a1.625 1.625 0 0 1-2.104-1.553v-1.206c0-1.085.563-2.093 1.487-2.661l3.873-2.385-5.03-5.03-.078-.085a1.125 1.125 0 0 1 1.584-1.584l.085.078 18 18 .077.085a1.126 1.126 0 0 1-1.583 1.583l-.085-.077-4.58-4.58v.018l1.085 1.086c.585.586.915 1.38.915 2.209zm-13.5-7.276L9.17 12.68a1.125 1.125 0 0 1 1.456 1.075V17.7c0 .298-.119.584-.33.795L8.882 19.91a.88.88 0 0 0-.257.619v.11l3.02-1.005.175-.044a1.1 1.1 0 0 1 .536.044l3.02 1.004v-.11a.87.87 0 0 0-.257-.618l-1.414-1.415a1.13 1.13 0 0 1-.33-.795v-2.733l-4.504-4.505-4.33 2.665a.88.88 0 0 0-.416.745v.36Z"
      />
    </svg>
  );
}
